import { KatAppLayout, KatButton, KatNavigation, KatPopover } from '@amzn/katal-react';
import React, { useState, Suspense } from 'react';
import { LocalizationContextBuilder } from '@amzn/arb-tools';
import { applicationNavigationRoutes } from 'src/core/hooks/useNavigationRoutes';
import { LoadingState } from 'src/features/components/granularSLA/LoadingState';
import { useUser } from 'src/utils/UserContext';
import { DEFAULT_LOCALE } from '../constants';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { CORA_PATH, SHIPMENT_HISTORY_PATH } from 'src/core/config/navigationRoutes';
import arbManifest from 'translations/arbManifest';
import { resolveBundleUrlWithFallbacks } from '../helpers';
import { getEnv } from 'src/utils/Environment';
import { ENV } from 'src/core/config/APIConstants';

const mbmOptions = {
    arbManifest,
    defaultLocalizationContext: new LocalizationContextBuilder().withLocale( DEFAULT_LOCALE ).withDefaultLocale( DEFAULT_LOCALE ).build(),
    resolveBundleUrl: (
        resourcePackPath: string | undefined,
        locale: string,
        bundle: string,
    ) => resolveBundleUrlWithFallbacks( resourcePackPath, locale, bundle ),
};

import ErrorBoundary from './ErrorBoundary';
import { memo } from 'react';

const App = memo(() =>
{

    const { granularSLALanding, granularSLARoute, bulkGranularSLARoute, r2fThresholdRoute, bulkR2fThresholdRoute, coraRoute, shipmentHistoryRoute } = applicationNavigationRoutes();
    const { user } = useUser();
    const [ isHelpOpen, setIsHelpOpen ] = useState( false );
    const location = useLocation();
    const isCORAPage = location.pathname === CORA_PATH || location.pathname.startsWith( `${CORA_PATH}/` ) || location.pathname.endsWith( '/cora' );
    const isShipmentHistoryPage = location.pathname === SHIPMENT_HISTORY_PATH || location.pathname.startsWith( `${SHIPMENT_HISTORY_PATH}/` );

    const permissionsAvailable = () =>
    {
        return <ul style={{ listStyle: 'none', padding: 0 }}>
            {user?.isAuthorizedForSLAOverrides && (
                <li style={{ marginBottom: '0.5rem' }}>
                    SLA Override Access
                </li>
            )}
            {user?.isDevAdmin && (
                <li style={{ marginBottom: '0.5rem' }}>
                    Developer Access
                </li>
            )}
        </ul>;
    };


    return (
            <KatAppLayout>
            <div className={'navigationHeader'}>
                {!isCORAPage && !isShipmentHistoryPage && (
                <KatNavigation slot='top' mode='horizontal'>
                    <div className={'nav-container'}>
                        <div className={'nav-links'}>
                            <Link to='/' className={'nav-item'}>Home</Link>
                            <Link to={granularSLALanding} className={'nav-item'}>SLA</Link>
                            <Link to={bulkGranularSLARoute} className={'nav-item'}>Bulk SLA</Link>
                            <Link to={r2fThresholdRoute} className={'nav-item'}>TRB Thresholds</Link>
                            <Link to={bulkR2fThresholdRoute} className={'nav-item'}>Bulk TRB Thresholds</Link>
                            {getEnv() !== ENV.PRODUCTION && (
                                <Link to={coraRoute} className={'nav-item'}>CORA</Link>
                            )}
                            {getEnv() !== ENV.PRODUCTION && (
                                <Link to={shipmentHistoryRoute} className={'nav-item'}>Shipment History</Link>
                            )}
                        </div>

                    </div>
                </KatNavigation>
                )}
                <div className={'profile-button'}>
                    <KatPopover katAriaBehavior='tooltip'
                                position='bottom'
                                triggerType='click'>
                        <KatButton
                            slot='trigger'
                            variant='secondary'>
                            Welcome {user?.login}
                        </KatButton>
                        <h4>Permissions Granted:</h4>
                        {permissionsAvailable()}
                        <h4>Support Resources</h4>
                        <ul>
                            <li>
                                <KatButton variant='link' onClick={() => window.open( '/support/new' )}>
                                    Create New Ticket
                                </KatButton>
                            </li>
                            <li>
                                <KatButton variant='link' onClick={() => window.open( '/support/knowledge-base' )}>
                                    Knowledge Base
                                </KatButton>
                            </li>
                        </ul>
                    </KatPopover>
                </div>
            </div>
            <div className={'main-content'}>
                    <Outlet />
            </div>

            <footer slot='bottom'></footer>
        </KatAppLayout>
    );
});

export default App;
